import React from 'react';
import { S } from './style';
import { APP } from '../../../config/app';
import headerLogo from '../../../asset/headerLogo.png';
export default function Header({ progress, progressTitle }) {
    return (<S.Layout>
      <S.LayoutTitle>
        <S.Logo src={headerLogo} alt='logo'/>
        <div>{progressTitle}</div>
      </S.LayoutTitle>
      <S.LayoutProgress>
        <S.Progress currentProgress={progress} totalProgress={APP.TOTAL_PAGE_PROGRESS_COUNT} isCompleted={progress === APP.TOTAL_PAGE_PROGRESS_COUNT}/>
      </S.LayoutProgress>
    </S.Layout>);
}
